import Big from 'big.js';

/** Validate that field is big.js compatible */
export const isBigCompatible = (value: unknown): value is string | number | Big | null | undefined => {
  return value == null || typeof value === 'string' || typeof value === 'number' || value instanceof Big;
};
